import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  BuyflowConfigLimits,
  BuyflowVesselSortConfig,
} from '../../buyflow-sort-filter-control/buyflow-sort-filter-control.component';

export interface DialogData {
  config: BuyflowVesselSortConfig;
  limits: BuyflowConfigLimits;
  moreFilterKeys: string[];
}

@Component({
  selector: 'app-more-filters-modal',
  templateUrl: './more-filters-modal.component.html',
  styleUrls: ['./more-filters-modal.component.scss'],
})
export class MoreFiltersModalComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<MoreFiltersModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  clearFilters() {
    for (let key of this.data.moreFilterKeys) {
      this.data.config[key] =
        this.data.limits['min' + key.charAt(0).toUpperCase() + key.slice(1)];
    }
    this.dialogRef.close();
  }

  decrementProperty(property: string): void {
    if (this.data.config[property] > 0) {
      this.data.config[property]--;
    }
  }

  incrementProperty(key: string): void {
    if (
      this.data.config[key] <
      this.data.limits['max' + key.charAt(0).toUpperCase() + key.slice(1)]
    ) {
      this.data.config[key]++;
    }
  }

  ngOnInit() {
    console.log(this.data);
  }

  ngOnDestroy(): void {}
}
